import { sport, oddsTypeUOF } from 'constants/enum';

const olybet = {
  [sport.soccer]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.soccer].live.three_way_live,
      oddsTypeUOF[sport.soccer].live.total,
      oddsTypeUOF[sport.soccer].live.nextgoal,
      oddsTypeUOF[sport.soccer].live.handicap,
      oddsTypeUOF[sport.soccer].live.total_first_half,
      oddsTypeUOF[sport.soccer].live.halftime_1x2,
      oddsTypeUOF[sport.soccer].live.goals_awayteam,
      oddsTypeUOF[sport.soccer].live.goals_hometeam,
      oddsTypeUOF[sport.soccer].live.draw_no_bet,
      oddsTypeUOF[sport.soccer].live.double_chance,
      oddsTypeUOF[sport.soccer].live.restofthematch,
      oddsTypeUOF[sport.soccer].live.ht_who_wins_the_rest,
      oddsTypeUOF[sport.soccer].live.asian_handicap,
      oddsTypeUOF[sport.soccer].live.asian_handicap_first_half,
      oddsTypeUOF[sport.soccer].live.three_way_only_ot,
      oddsTypeUOF[sport.soccer].live.total_live_only_ot,
      oddsTypeUOF[sport.soccer].live.next_goal_only_ot,
      oddsTypeUOF[sport.soccer].live.rest_of_match_only_ot,
      oddsTypeUOF[sport.soccer].live.win_penalties,
    ],
  },
  [sport.basketball]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.basketball].live.two_way_live_ot,
      oddsTypeUOF[sport.basketball].live.total_incl_ot,
      oddsTypeUOF[sport.basketball].live.asian_handicap_ot,
      oddsTypeUOF[sport.basketball].live.win_current_period,
      oddsTypeUOF[sport.basketball].live.total_current_round,
      oddsTypeUOF[sport.basketball].live.handicap_current_period,
      oddsTypeUOF[sport.basketball].live.race_to_points,
      oddsTypeUOF[sport.basketball].live.two_way_fist_half,
      oddsTypeUOF[sport.basketball].live.total_first_half,
      oddsTypeUOF[sport.basketball].live.asian_handicap_first_half,
      oddsTypeUOF[sport.basketball].live.who_scores_point,
      oddsTypeUOF[sport.basketball].live.nextgoal,
      oddsTypeUOF[sport.basketball].live.goals_awayteam,
      oddsTypeUOF[sport.basketball].live.goals_hometeam,
    ],
  },
  [sport.ice_hockey]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.ice_hockey].live.three_way_live,
      oddsTypeUOF[sport.ice_hockey].live.nextgoal,
      oddsTypeUOF[sport.ice_hockey].live.total,
      oddsTypeUOF[sport.ice_hockey].live.handicap,
      oddsTypeUOF[sport.ice_hockey].live.win_current_period,
      oddsTypeUOF[sport.ice_hockey].live.total_current_round,
      oddsTypeUOF[sport.ice_hockey].live.goals_awayteam,
      oddsTypeUOF[sport.ice_hockey].live.goals_hometeam,
      oddsTypeUOF[sport.ice_hockey].live.restofthematch,
      oddsTypeUOF[sport.ice_hockey].live.rest_of_period,
      oddsTypeUOF[sport.ice_hockey].live.draw_no_bet,
      oddsTypeUOF[sport.ice_hockey].live.double_chance,
    ],
  },
  [sport.tennis]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.tennis].live.win_tennis_match,
      oddsTypeUOF[sport.tennis].live.win_tennis_set,
      oddsTypeUOF[sport.tennis].live.win_tennis_game,
      oddsTypeUOF[sport.tennis].live.total_games_in_match,
      oddsTypeUOF[sport.tennis].live.tennis_results,
      oddsTypeUOF[sport.tennis].live.total_current_round,
      oddsTypeUOF[sport.tennis].live.set_handicap,
      oddsTypeUOF[sport.tennis].live.tennis_number_of_sets,
      oddsTypeUOF[sport.tennis].live.win_games_of_set,
      oddsTypeUOF[sport.tennis].live.tiebreak_in_set,
    ],
  },
  [sport.handball]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.handball].live.three_way_live,
      oddsTypeUOF[sport.handball].live.handicap,
      oddsTypeUOF[sport.handball].live.total,
      oddsTypeUOF[sport.handball].live.halftime_1x2,
      oddsTypeUOF[sport.handball].live.handicap_first_half,
      oddsTypeUOF[sport.handball].live.total_first_half,
      oddsTypeUOF[sport.handball].live.who_scores_point,
      oddsTypeUOF[sport.handball].live.race_to_points,
      oddsTypeUOF[sport.handball].live.nextgoal,
      oddsTypeUOF[sport.handball].live.asian_handicap,
      oddsTypeUOF[sport.handball].live.asian_handicap_first_half,
      oddsTypeUOF[sport.handball].live.goals_awayteam,
      oddsTypeUOF[sport.handball].live.goals_hometeam,
    ],
  },
  [sport.table_tennis]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.table_tennis].live.two_way_live,
      oddsTypeUOF[sport.table_tennis].live.total,
      oddsTypeUOF[sport.table_tennis].live.win_current_period,
      oddsTypeUOF[sport.table_tennis].live.who_scores_point,
      oddsTypeUOF[sport.table_tennis].live.race_to_points,
      oddsTypeUOF[sport.table_tennis].live.asian_handicap,
      oddsTypeUOF[sport.table_tennis].live.tennis_results,
      oddsTypeUOF[sport.table_tennis].live.total_current_round,
      oddsTypeUOF[sport.table_tennis].live.handicap_current_period,
      oddsTypeUOF[sport.table_tennis].live.tennis_number_of_sets,
    ],
  },
  [sport.volleyball]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.volleyball].live.two_way_live,
      oddsTypeUOF[sport.volleyball].live.asian_handicap,
      oddsTypeUOF[sport.volleyball].live.win_current_period,
      oddsTypeUOF[sport.volleyball].live.who_scores_point,
      oddsTypeUOF[sport.volleyball].live.tennis_results,
      oddsTypeUOF[sport.volleyball].live.handicap_current_period,
      oddsTypeUOF[sport.volleyball].live.total_current_round,
      oddsTypeUOF[sport.volleyball].live.total,
      oddsTypeUOF[sport.volleyball].live.race_to_points,
      oddsTypeUOF[sport.volleyball].live.nextgoal,
    ],
  },
  [sport.futsal]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.futsal].live.three_way_live,
      oddsTypeUOF[sport.futsal].live.nextgoal,
      oddsTypeUOF[sport.futsal].live.asian_handicap,
      oddsTypeUOF[sport.futsal].live.total,
      oddsTypeUOF[sport.futsal].live.halftime_1x2,
      oddsTypeUOF[sport.futsal].live.total_first_half,
      oddsTypeUOF[sport.futsal].live.goals_awayteam,
      oddsTypeUOF[sport.futsal].live.goals_hometeam,
      oddsTypeUOF[sport.futsal].live.restofthematch,
      oddsTypeUOF[sport.futsal].live.asian_handicap_first_half,
      oddsTypeUOF[sport.futsal].live.ht_who_wins_the_rest,
    ],
  },
  [sport.beach_volley]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.beach_volley].live.two_way_live,
      oddsTypeUOF[sport.beach_volley].live.asian_handicap,
      oddsTypeUOF[sport.beach_volley].live.win_current_period,
      oddsTypeUOF[sport.beach_volley].live.who_scores_point,
      oddsTypeUOF[sport.beach_volley].live.tennis_results,
      oddsTypeUOF[sport.beach_volley].live.handicap_current_period,
      oddsTypeUOF[sport.beach_volley].live.total_current_round,
      oddsTypeUOF[sport.beach_volley].live.total,
      oddsTypeUOF[sport.beach_volley].live.race_to_points,
      oddsTypeUOF[sport.beach_volley].live.nextgoal,
    ],
  },
};


export default olybet;
